import _ from 'lodash';
import { cards as Cards } from '@breezeway/brzw-components';
import { getCloudinaryUrl } from '../../utils/image';

const {
  HEIGHT_DESKTOP,
  WIDTH_DESKTOP,
  HEIGHT_MOBILE,
  WIDTH_MOBILE,
} = Cards.constants.NORMAL_CARD_SIZES;

const {
  HEIGHT_DESKTOP: SMALL_HEIGHT_DESKTOP,
  WIDTH_DESKTOP: SMALL_WIDTH_DESKTOP,
  HEIGHT_MOBILE: SMALL_HEIGHT_MOBILE,
  WIDTH_MOBILE: SMALL_WIDTH_MOBILE,
} = Cards.constants.SMALL_CARD_SIZES;

const CardImagePathHelper = (photo, isSmall, isMobile) => {
  const photoBucket = _.get(photo, 'bucket');
  const photoKey = _.get(photo, 'photo_key');
  let height;
  let width;

  if (!isSmall) {
    height = HEIGHT_DESKTOP;
    width = WIDTH_DESKTOP;
    if (isMobile) {
      height = HEIGHT_MOBILE;
      width = WIDTH_MOBILE;
    }
  }

  if (isSmall) {
    height = SMALL_HEIGHT_DESKTOP;
    width = SMALL_WIDTH_DESKTOP;
    if (isMobile) {
      height = SMALL_HEIGHT_MOBILE;
      width = SMALL_WIDTH_MOBILE;
    }
  }

  if (photoKey && photoBucket) {
    return getCloudinaryUrl(`${photoBucket}/${photoKey}`, {
      crop: 'fill',
      height,
      width,
    });
  }
  return null;
};

export default CardImagePathHelper;
